var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-info", attrs: { id: "helpContact" } },
    [
      _c("div", { staticClass: "grid-x center" }, [
        _c("h3", { staticClass: "need-help" }, [_vm._v("Need Help?")]),
        _vm._v(" "),
        _c("h2", { staticClass: "phone-number-need-help" }, [
          _vm._v(_vm._s(_vm._f("phone")(_vm.insuranceType.phone)))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "schedule-need-help" },
          [
            _vm.insuranceType && _vm.insuranceType.hours
              ? _c("pretty-schedule", {
                  attrs: {
                    schedule: _vm.insuranceType.hours,
                    schedule2: _vm.insuranceType.hours2
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "email-need-help" }, [
          _c("a", { attrs: { href: "mailto:" + this.insuranceType.email } }, [
            _vm._v(_vm._s(_vm.insuranceType.email))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf6728b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf6728b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/help-contact.vue
// module id = null
// module chunks = 